// TODO: change wasteWaterFacility variables to facility
import { createEntityAdapter } from "@reduxjs/toolkit";

export const wastewaterFacilitiesAdapter = createEntityAdapter({});
